import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		cardContent: {
			"&:hover .actions": {
				visibility: "visible"
			},
			"& .actions": {
				visibility: "hidden"
			}
		},
		agentLabel: {
			margin: 10,
		},
		position: {
			minWidth: 40,
		},
		positionItem: {
			display: "flex", 
			justifyContent: "flex-end", 
			flexGrow: 1,
		},
		deleteItem: {
			display: "flex", justifyContent: "flex-end"
		}
	} satisfies Record<string, CSSObject>)
};
